import { Button, Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "AppContext";
import CommonPagination from "components/CommonPagination";
import GKTable from "components/GKTable";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import { QueryKeys } from "utils/queryKey";
import CreateCompanyModal from "./Components/UpdateCompany/CreateCompanyModal";

const columns = [
  {
    headerName: "Company Name",
    field: "name",
    flex: 1,
    minWidth: 350,
    disableColumnMenu: true,
  },
  {
    headerName: "CMP",
    field: "cmp",
    flex: 1,
    type: "number",
    minWidth: 150,
    disableColumnMenu: true,
  },
  {
    headerName: "BSE Code",
    field: "bseCode",
    flex: 1,
    type: "number",
    minWidth: 150,
    disableColumnMenu: true,
  },
  {
    headerName: "IsinCode",
    field: "isinCode",
    flex: 1,
    minWidth: 150,
    disableColumnMenu: true,
  },
  {
    headerName: "NSE Code",
    field: "nseCode",
    flex: 1,
    minWidth: 150,
    disableColumnMenu: true,
  },
  {
    headerName: "Type",
    field: "instType",
    flex: 1,
    minWidth: 150,
    disableColumnMenu: true,
  },
  {
    headerName: "Sub Type",
    field: "instSubType",
    flex: 1,
    minWidth: 150,
    disableColumnMenu: true,
  },
];

const CompanyMasterMainPage = () => {
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();

  const {
    state: { currentUser },
  } = useAppContext();

  const isDisabled = currentUser?.phone === "9911223344";

  const {
    state: { commonFilter },
  } = useAppContext();

  const requestBody = {
    take: commonFilter?.companyList?.take,
    skip: commonFilter?.companyList?.skip,
    sort: JSON.stringify(
      commonFilter?.companyList?.sortModel?.map((data) => {
        return {
          selector: data.field,
          desc: data.sort !== "asc",
        };
      })
    ),
    search: commonFilter?.companyList?.search || "",
  };

  const { data, isFetching, refetch } = useQuery({
    queryKey: [QueryKeys.COMPANY_NAMES, requestBody],
    queryFn: async () =>
      axiosInstance.get("/admin-instrument/", { params: requestBody }),
  });

  const cusPagination = () => {
    return (
      <CommonPagination
        name="companyList"
        totalCount={data?.data?.totalCount || 0}
      />
    );
  };

  return (
    <DashboardLayout
      title="Company Master"
      breadcrumbs={[
        {
          name: "Company Master",
          path: "/app/company-master",
        },
      ]}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <GKTable
            loading={isFetching}
            columns={columns}
            rows={data?.data?.data || []}
            maxHeight={"calc(100vh - 190px)"}
            searchPlaceholder="Search for company"
            CustomPagination={!isFetching && cusPagination}
            onRowClick={(row) => {
              navigate(`/app/company-master/update/${row.row.gcode}`);
            }}
            pinnedColumns={{
              left: ["hierarchy", "name"],
            }}
            filterButton={false}
            zeroHolding
            name="companyList"
            headerComponent={
              <Grid container item xs={12} gap={1} justifyContent="flex-end">
                <Button
                  sx={{
                    fontSize: "0.7rem",
                    fontFamily: '"Arial", sans-serif',
                    textTransform: "none",
                  }}
                  onClick={() => navigate("/app/company-master/unique-company")}
                  variant="contained"
                >
                  Unique company
                </Button>
                <Button
                  sx={{
                    fontSize: "0.7rem",
                    fontFamily: '"Arial", sans-serif',
                    textTransform: "none",
                  }}
                  onClick={() => setOpenModal(true)}
                  variant="contained"
                  disabled={isDisabled}
                >
                  Add Company
                </Button>
              </Grid>
            }
            tableName="Company_List"
          />
        </Grid>
      </Grid>

      {openModal && (
        <CreateCompanyModal
          isModalOpen={openModal}
          setIsModalOpen={setOpenModal}
          refetch={refetch}
        />
      )}
    </DashboardLayout>
  );
};

export default CompanyMasterMainPage;
